import { useNavigate } from "react-router-dom";
import Carousel from "../Carousel";
import SectionHdr from "../SectionHeader";

export default function FullLibrarySection({ books = [], onView, cart, addCart }) {
    const navigate = useNavigate();

    if (books.length === 0) return null;

    return (
        <section className="section" style={{
            background: "white",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderTop: "3px solid #C0392B"
        }}>
            <Carousel
                books={books.slice(0, 16)}
                onView={onView}
                cart={cart}
                addCart={addCart}
                renderHeader={(dots) => (
                    <SectionHdr
                        pill="FULL LIBRARY"
                        action="View full library"
                        onAction={() => navigate("/store")}
                        rightContent={dots}
                    />
                )}
            />
        </section>
    );
}